__turbopack_context__.v({
  "error": "FranchiseRemarketing-module-scss-module__KuzITa__error",
  "formContainer": "FranchiseRemarketing-module-scss-module__KuzITa__formContainer",
});
